module.exports = __webpack_public_path__ + "static/media/enflag.77f22122.png";